import { useCallback, useEffect, useMemo, useState } from 'react';

interface GetAlertReturnType {
  shown: boolean;
  setAddCount: (newCount?: number) => void;
}

export const useAlert = (): GetAlertReturnType => {
  const [shown, setShown] = useState(false);
  const [count, setCount] = useState(0);

  const setAddCount = useCallback(() => setCount((prevState) => prevState + 1), []);

  useEffect(() => {
    if (count < 5) return;

    setShown(true);
    setTimeout(() => {
      setShown(false);
      setCount(0);
    }, 10000);
  }, [count]);

  return useMemo(
    () => ({
      shown,
      setAddCount,
    }),
    [shown, setAddCount],
  );
};
